import React from 'react';
import { AnimatePresence, motion } from 'motion/react';
import { theme } from '../../styles/theme';
import { useIsMobile } from '../../hooks/useIsMobile';
import { TOTAL_STEPS, type Direction } from './useStepFlow';

interface StepCardProps {
  step: number;
  direction: Direction;
  children: React.ReactNode;
  style?: React.CSSProperties;
}

export function StepCard({ step, direction, children, style }: StepCardProps) {
  const mobile = useIsMobile();
  const xFrom = direction === 'forward' ? 48 : -48;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', ...style }}>
      {/* Progress indicator */}
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', gap: theme.spacing.sm, marginBottom: mobile ? theme.spacing.lg : theme.spacing['2xl'] }}>
        <span style={{
          fontSize: theme.fontSize.xs,
          fontWeight: theme.fontWeight.bold,
          textTransform: 'uppercase',
          letterSpacing: '0.12em',
          color: theme.colors.muted,
        }}>
          {Math.round(step / TOTAL_STEPS * 100)}% Complete
        </span>
        <div style={{ display: 'flex', gap: theme.spacing.xs }}>
          {Array.from({ length: TOTAL_STEPS }, (_, i) => (
            <div key={i} style={{
              width: mobile ? 24 : 32,
              height: 4,
              borderRadius: theme.borderRadius.full,
              background: i < step ? theme.colors.teal : theme.colors.borderLight,
              transition: 'all 0.5s ease',
            }} />
          ))}
        </div>
      </div>

      <div style={{ flex: 1, overflow: 'auto', padding: mobile ? `0 ${theme.spacing.md} ${theme.spacing.lg}` : `0 ${theme.spacing['2xl']} ${theme.spacing['2xl']}`, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <AnimatePresence mode="wait" initial={false}>
          <motion.div
            key={step}
            initial={{ opacity: 0, x: xFrom }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: -xFrom }}
            transition={{ duration: 0.28, ease: [0.4, 0, 0.2, 1] }}
            style={{ width: '100%' }}
          >
            {children}
          </motion.div>
        </AnimatePresence>
      </div>
    </div>
  );
}
